import { LoginForm } from '../modules/Authentication';
import { useNavigate } from 'react-router-dom';

/**
 * Login Page
 * Entry point for authentication
 * Detects subdomain and passes appropriate panel prop
 */
function LoginPage({ panel: panelProp }) {
    const navigate = useNavigate();

    // Detect subdomain to determine login panel
    const getPanel = () => {
        const hostname = window.location.hostname;
        const subdomain = hostname.split('.')[0];

        if (subdomain === 'admin') {
            return 'admin';
        } else if (subdomain === 'operator') {
            return 'operator';
        }
        return 'user';
    };

    const handleLogin = (user) => {
        // Redirect to appropriate dashboard based on user role
        if (user?.role === 'admin') {
            navigate('/admin/dashboard');
        } else if (user?.role === 'operator') {
            navigate('/operator/dashboard');
        } else {
            navigate('/dashboard');
        }
    };

    const panel = panelProp || getPanel();

    return <LoginForm onLogin={handleLogin} panel={panel} />;
}

export default LoginPage;
